<template>
    <div class="example-avatar" id="upload-avatar">
        <div>
            <div class="avatar-upload p-10 bck-dropzone border-1" v-show="!edit">
                <div class="text-center">
                    <label for="avatar">
                        <i class="fa fa-inbox fa-3x"></i>
                        <div class="col col-lg-12 text-center">
                            <br/>
                            <span class="p-1">{{ $t('tabs.photo.instructions')}}</span>
                        </div>
                    </label>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-show="mida_superada">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                    <strong>Oh oh!</strong> {{ $t('tabs.photo.errors.mida_superada')}}
                </div>

                <div class="text-center p-2">
                    <file-upload style="max-height:270px"
                            extensions="gif,jpg,jpeg,png"
                            accept="image/png,image/gif,image/jpeg"
                            name="file"
                            class="btn btn-warning"
                            :thread="1"
                            :maximum="1"
                            :size="1024 * 1024"
                            :drop="!edit"
                            v-model="files"
                            @input-file="inputFile"
                            @input-filter="inputFilter"
                            @input="updatedValue"
                            ref="upload">

                            <i class="fa fa-plus"></i>
                      {{ $t('tabs.photo.add_photo')}}
                    </file-upload>
                </div>
            </div>
            <div class="avatar-edit" v-show="files.length && edit">
                <div class="avatar-edit-image" v-if="files.length">
                    <img ref="editImage" :src="files[0].url" class="cropper-hidden"/>
                </div>
                <div class="text-center p-4">
                  <button type="submit" class="btn btn-warning" @click.prevent="cropImage"><i class="fas fa-crop"></i> {{ $t('tabs.photo.crop_photo')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.min.css'
import 'cropperjs/dist/cropper'
import FileUpload from 'vue-upload-component'

export default {
        name: 'upload-avatar',
        components: {
            FileUpload,
        },
        data() {
            return {
                files: [],
                edit: false,
                cropper: false,
                teSolicitudPendent: false,
                mida_superada:false,
            }
        },
        watch: {
            edit(value) {
                if (value) {
                    this.$nextTick(function () {
                        if (!this.$refs.editImage) {
                            return;
                        }

                      this.cropper = new Cropper(this.$refs.editImage, {
                          minContainerWidth: 420,
                          minContainerHeight: 340,
                          minCanvasWidth: 420,
                          minCanvasHeight: 240,
                          minCropBoxWidth: 150,
                          minCropBoxHeight: 190,
                          cropBoxResizable: true,
                          movable: true,
                          dragMode: 'move',
                          viewMode: 1,
                          initialAspectRatio: 1 / 2,
                          aspectRatio: 12 / 16,
                          autoCropArea: 1,
                        })
                    })
                } else {
                    if (this.cropper) {
                        this.cropper.destroy()
                        this.cropper = false
                    }
                }
            }
        },
        methods: {
            updatedValue(value){
              console.log(value);
            },
            cropImage() {
                this.edit = false
                let oldFile = this.files[0]
                let binStr = atob(this.cropper.getCroppedCanvas({
                    imageSmoothingQuality: 'high'
                }).toDataURL(oldFile.type).split(',')[1])
                let arr = new Uint8Array(binStr.length)
                for (let i = 0; i < binStr.length; i++) {
                    arr[i] = binStr.charCodeAt(i)
                }
                let file = new File([arr], oldFile.name, { type: oldFile.type })
                this.$refs.upload.active = true;
                this.$emit('takedPhoto', file);
                this.$refs.upload.update(oldFile.id, {
                    file,
                    type: file.type,
                    size: file.size,
                    active: false,
                })
            },
            inputFile(newFile, oldFile) {

                if (newFile.size > 1024 * 1024 * 4) {
                    this.mida_superada = true;
                    this.edit = false;
                    this.$refs.upload.clear();
                    return;
                }

              this.checkImageDimensions(newFile.file)
                  .catch(() => {
                    this.mida_superada = true;
                    this.edit = false;
                    this.$refs.upload.clear();
                  });

                this.mida_superada = false;
                if (newFile && !oldFile) {
                    this.$nextTick(function () {
                        this.edit = true
                    })
                }
                if (!newFile && oldFile) {
                    this.edit = false
                }

                if (newFile && oldFile && !newFile.active && oldFile.active) {
                    if (newFile.xhr) {
                        //  Get the response status code
                        let status = newFile.xhr.status;
                        // Get response data
                        let message = newFile.response.message;

                        //console.log('response', newFile.response)
                        //console.log('status', status)
                        if(status === 200) {
                            // Crida per ShowCarnet
                            this.$root.$emit('uploadImage');
                            console.log('Save Photo');
                            this.$refs.upload.clear();
                            this.$awn.success(message);
                        }
                        else {
                            this.$awn.error(message);
                            this.$refs.upload.active = false;
                        }
                    }
                }
            },
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    if (!/\.(gif|jpg|jpeg|png)$/i.test(newFile.name)) {
                        this.alert('No és una imatge')
                        return prevent()
                    }
                }

                if (newFile && (!oldFile || newFile.file !== oldFile.file)) {

                    newFile.url = ''
                    let URL = window.URL || window.webkitURL
                    if (URL && URL.createObjectURL) {
                        newFile.url = URL.createObjectURL(newFile.file)
                    }
                }
            },
            checkImageDimensions(file) {
              return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => {
                  const img = new Image();
                  img.onload = () => {
                    const width = img.width;
                    const height = img.height;
                    if (width < 172 || height < 220) {
                      reject(new Error('Image dimensions are invalid'));
                    } else {
                      resolve(true);
                    }
                  };
                  img.src = event.target.result;
                };
                reader.onerror = () => {
                  reject(new Error('Error reading image file'));
                };
                reader.readAsDataURL(file);
              });
            },
        }
    }
</script>

<style>
    .bck-dropzone {
        border: 2px solid #e5e5e5;
        font-family: Arial,sans-serif;
        letter-spacing: .2px;
        color: #777;
        transition: .2s linear;
        background-color: #f6f6f6;
    }

    .example-avatar .avatar-upload .photo-size {
        width: 150px;
        height: 190px;
        border-radius: 5% !important;
    }
    .example-avatar .text-center .btn {
        margin: 0 .5rem
    }
    .example-avatar .avatar-edit-image {
        max-width: 100%
    }
    .example-avatar .drop-active {
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        position: fixed;
        z-index: 9999;
        opacity: .6;
        text-align: center;
        background: #000;
    }
    .example-avatar .drop-active h3 {
        margin: -.5em 0 0;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 40px;
        color: #fff;
        padding: 0;
    }
    .p-10 {
      padding: 4em 2em 3em 2em;
    }

</style>
